import "typeface-nunito"


export default {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    letterSpacing: '-0.24px'
  },
  h2: {
    fontWeight: 800,
    fontSize: 46,
    letterSpacing: '0.3px',
    textAlign: 'center', 
    fontFamily: 'Nunito'
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: '-0.06px'
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '-0.06px'
  },
  h5: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px'
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  },
};
